import { createContext, useContext } from 'react';

export interface CanvasEditorViewport {
  scale: number;
  tx: number;
  ty: number;
}

export const CanvasEditorViewportContext = createContext<CanvasEditorViewport>({ scale: 1, tx: 0, ty: 0 });

/** Huidige zoom/pan-stand van CanvasEditorStage -- frames hebben `scale`
 * nodig om schermpixel-sleepbewegingen naar bordpixels terug te schalen
 * (frameGeometry.screenDeltaToLocalDelta). */
export function useCanvasEditorViewport(): CanvasEditorViewport {
  return useContext(CanvasEditorViewportContext);
}
